import React from 'react';
import Iconography from '@hid-galaxy-ui/galaxy-react/components/Iconography';
import {
  IconographySizes,
  IconographyThemes,
} from '@hid-galaxy-ui/galaxy-react/components/Iconography/iconEnums';

interface IIcon {
  className?: string;
  iconName: string;
  size?: IconographySizes;
  theme?: IconographyThemes;
}

const Icon: React.FC<IIcon> = ({
  className,
  iconName,
  size = IconographySizes.Small,
  theme,
}): JSX.Element => {
  const IconComponent = <Iconography icon={iconName} size={size} theme={theme} />;
  return className ? <span className={className}>{IconComponent}</span> : IconComponent;
};

export default Icon;
